// Review-time labels for Checks → Sign off (docs/validation-autopilot-spec.md §6).
// Target: median human minutes per sign-off <= 12 (from ~70).
export const REVIEW_TARGET_MINUTES = 12;

const isNum = (n) => typeof n === 'number' && Number.isFinite(n) && n >= 0;

/** "Review time: 7.3 min" for a signed launch, or '' when nothing was measured. */
export function reviewTimeLabel(review) {
  return review && isNum(review.humanMinutes) ? `Review time: ${review.humanMinutes} min` : '';
}

/** "Median review time: 9.5 min over 4 sign-offs (target ≤ 12)" or '' when there is no data. */
export function reviewMedianLabel(summary) {
  if (!summary || !isNum(summary.medianMinutes) || !(summary.count > 0)) return '';
  const n = summary.count;
  return `Median review time: ${summary.medianMinutes} min over ${n} sign-off${n === 1 ? '' : 's'} (target ≤ ${REVIEW_TARGET_MINUTES})`;
}

/** true when the median is within target; null when unknown. */
export function reviewWithinTarget(summary) {
  return summary && isNum(summary.medianMinutes) && summary.count > 0 ? summary.medianMinutes <= REVIEW_TARGET_MINUTES : null;
}
